import { loadScript } from "../ScriptLoader";

const GOOGLE_RECAPTCHA_BASE_URL =
	"https://www.google.com/recaptcha/enterprise.js" as const;
const GOOGLE_RECAPTCHA_KEY = "grecaptcha" as const;

const loadReCAPTCHAScript = async (reCAPTCHAKey: string) =>
	await loadScript(
		`${GOOGLE_RECAPTCHA_BASE_URL}?render=${reCAPTCHAKey}`,
		GOOGLE_RECAPTCHA_KEY,
	);

export default loadReCAPTCHAScript;
